/**
 * Boniti — Popup triggers
 * Handles: #appointment | #trade-enquiry-popup | #product-enquiry
 */

// ─── iOS scroll fix ───────────────────────────────────────────────────────────
// The theme's body-scroll-lock library blocks ALL touchmove events inside
// popups on iOS. We patch this by intercepting touchmove on the scrollable
// container and stopping propagation before the document-level lock fires.

function enableIOSScrollForPopup(handle) {
  setTimeout(() => {
    const popupEl = document.querySelector(`[data-popup][data-popup-handle="${handle}"]`);
    if (!popupEl) return;

    const scrollEl = popupEl.querySelector('.popup__text-container');
    if (!scrollEl || scrollEl._iosScrollPatched) return;

    let startY = 0;

    scrollEl.addEventListener('touchstart', e => {
      startY = e.targetTouches[0].clientY;
    }, { passive: true });

    scrollEl.addEventListener('touchmove', e => {
      const deltaY = e.targetTouches[0].clientY - startY;
      const atTop = scrollEl.scrollTop === 0;
      const atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 1;

      // At boundary in the direction of travel — let the lock prevent scroll
      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) return;

      // Otherwise stop the event reaching the document-level lock listener
      e.stopPropagation();
    }, { passive: true });

    scrollEl._iosScrollPatched = true;
  }, 400); // After popup open animation completes
}


// ─── Shared utility ───────────────────────────────────────────────────────────

function openPopupWithRetry(handle, onSuccess, attempts, delay) {
  if (attempts <= 0) {
    console.warn(`Popup tab not found for handle "${handle}" after multiple attempts.`);
    return;
  }
  setTimeout(() => {
    const popupEl = document.querySelector(`[data-popup][data-popup-handle="${handle}"]`);
    if (!popupEl) { openPopupWithRetry(handle, onSuccess, attempts - 1, delay * 2); return; }

    const id = popupEl.getAttribute("data-id");
    if (!id) { openPopupWithRetry(handle, onSuccess, attempts - 1, delay * 2); return; }

    const tabBtn = document.querySelector(`.popup__tab[data-id="${CSS.escape(id)}"] .popup__tab-button`);
    if (!tabBtn) { openPopupWithRetry(handle, onSuccess, attempts - 1, delay * 2); return; }

    tabBtn.click();
    if (onSuccess) onSuccess();

    // Focus first input after animation — fixes autofill not triggering on first tap
    setTimeout(() => {
      const firstInput = popupEl.querySelector('input:not([type="hidden"]):not([type="checkbox"])');
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 350);

    // Patch iOS scroll lock
    enableIOSScrollForPopup(handle);

  }, delay);
}

// ─── Product data helper ──────────────────────────────────────────────────────

function getProductData() {
  const quoteBtn = document.querySelector('[data-quote-modal-trigger]');
  if (quoteBtn && quoteBtn.dataset.productTitle) {
    return {
      title: quoteBtn.dataset.productTitle,
      url: window.location.origin + (quoteBtn.dataset.productUrl || window.location.pathname)
    };
  }
  if (window.location.pathname.includes('/products/')) {
    const h1 = document.querySelector('.product__title, h1.ff-heading, h1');
    return {
      title: h1 ? h1.textContent.trim() : '',
      url: window.location.href
    };
  }
  return null;
}


// ─── Appointment popup ────────────────────────────────────────────────────────

(() => {
  const HASH = "#appointment";

  function open() {
    openPopupWithRetry("appointment", null, 8, 100);
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (!href.endsWith(HASH)) return;
    if (href === HASH || href.startsWith('#')) {
      e.preventDefault();
      open();
    }
  });

  function handleHash() {
    if (window.location.hash !== HASH) return;
    open();
  }

  window.addEventListener("DOMContentLoaded", handleHash);
  window.addEventListener("hashchange", handleHash);
})();


// ─── Trade enquiry popup ──────────────────────────────────────────────────────

(() => {
  const HASH = "#trade-enquiry-popup";

  function populateProductData() {
    const data = getProductData();
    if (!data) return;
    const titleEl    = document.querySelector('[data-trade-modal-product-title]');
    const titleField = document.querySelector('[data-trade-field-product-title]');
    const urlField   = document.querySelector('[data-trade-field-product-url]');
    if (titleEl)    titleEl.textContent = data.title;
    if (titleField) titleField.value    = data.title;
    if (urlField)   urlField.value      = data.url;
  }

  function open() {
    openPopupWithRetry("trade-enquiry", populateProductData, 8, 100);
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (!href.endsWith(HASH)) return;
    if (href === HASH || href.startsWith('#')) {
      e.preventDefault();
      open();
    }
  });

  function handleHash() {
    if (window.location.hash !== HASH) return;
    open();
  }

  window.addEventListener("DOMContentLoaded", handleHash);
  window.addEventListener("hashchange", handleHash);
})();


// ─── Product enquiry popup ────────────────────────────────────────────────────

(() => {
  const HASH = "#product-enquiry";

  function populateProductData() {
    const data = getProductData();
    if (!data) return;
    const titleEl    = document.querySelector('[data-enquiry-modal-product-title]');
    const titleField = document.querySelector('[data-enquiry-field-product-title]');
    const urlField   = document.querySelector('[data-enquiry-field-product-url]');
    if (titleEl)    titleEl.textContent = data.title;
    if (titleField) titleField.value    = data.title;
    if (urlField)   urlField.value      = data.url;
  }

  function open() {
    openPopupWithRetry("product-enquiry", populateProductData, 8, 100);
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (!href.endsWith(HASH)) return;
    if (href === HASH || href.startsWith('#')) {
      e.preventDefault();
      open();
    }
  });

  function handleHash() {
    if (window.location.hash !== HASH) return;
    open();
  }

  window.addEventListener("DOMContentLoaded", handleHash);
  window.addEventListener("hashchange", handleHash);
})();